import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/variables.css'
import './index.css'
import App from './App.tsx'

if (window.location.hostname === 'localhost') {
  const redirectedUrl = new URL(window.location.href)
  redirectedUrl.hostname = '127.0.0.1'
  window.location.replace(redirectedUrl.toString())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
